














































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { InformacaoPartoFormData, TipoInformacaoParto } from '../../../../back/src/types';
import { Usuario } from '../../../../back/src/entity/Usuario';

export default Vue.extend({
  name: 'InformacoesPartosForm',
  props: {
    pacienteId: {
      type: Number,
      required: true,
    },
    internacaoId: {
      type: Number,
      required: true,
    },
    tipoInformacaoParto: {
      type: String as () => TipoInformacaoParto,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      menuData: false,
      loading: {
        usuarios: true,
        submit: false,
      },
      usuarios: [] as Usuario[],
      form: {
        data: null,
        hora: null,
        observacoes: null,
        responsavelId: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        hora: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (v && timePattern.test(v)) || 'Horário inválido';
          },
        ],
      },
      TipoInformacaoParto,
    };
  },
  mounted() {
    this.buscaUsuarios();
    this.form.data = moment(new Date()).format('YYYY-MM-DD');
    this.form.hora = moment(new Date()).format('HH:mm');
    this.form.responsavelId = _.get(this.$store.getters.usuario, 'id', null);
  },
  computed: {
    formInformacaoParto():
      Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formInformacaoParto as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
    dataFormatada(): string {
      if (this.form.data) {
        const momentData = moment(this.form.data);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    usuariosItens() {
      return _.orderBy(
        _.map(_.filter(this.usuarios, usuario => !usuario.email.includes('@kemiocode')),
          usuario => ({ value: usuario.id, text: usuario.nome })),
        ['text'],
      );
    },
  },
  methods: {
    async buscaUsuarios() {
      this.loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuarios = false;
      }
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formInformacaoParto.validate()) {
        return;
      }
      const formData: InformacaoPartoFormData = {
        paciente_id: this.pacienteId,
        internacao_id: this.internacaoId,
        tipo: this.tipoInformacaoParto,
        datetime_informacao: moment(`${this.form.data} ${this.form.hora}`).toDate(),
        observacoes: this.form.observacoes.trim(),
        responsavel_id: this.form.responsavelId,
      };
      this.loading.submit = true;
      try {
        const response = await Requester.informacaoParto.criaInformacaoParto(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Informação registrada com sucesso.' });
          this.limpaForm();
          this.formInformacaoParto.resetValidation();
          this.$emit('nova-informacao-parto', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
    limpaForm() {
      this.form = {
        data: null,
        hora: null,
        observacoes: null,
        usuario: null,
      };
    },
  },
});
